const settings = {
    apiURL: import.meta.env.VITE_API_URL || 'http://localhost:3001',
};

export default settings;
